<template>
  <div class="scr">
    <!-- ===== BERANDA ===== -->
    <template v-if="screen === 'home'">
      <div class="scr__header">
        <div>
          <div class="scr__eyebrow">Selamat pagi, Rina</div>
          <div class="scr__household">Keluarga Santoso <i class="fa fa-angle-down"></i></div>
        </div>
        <div class="scr__header-actions">
          <span class="scr__icon-btn"><i class="fa fa-bell"></i><span class="scr__badge-dot"></span></span>
          <span class="scr__avatar scr__avatar--rina">R</span>
        </div>
      </div>
      <div class="scr__body">
        <div class="scr__hero-card">
          <div class="scr__hero-label">Pengeluaran Oktober</div>
          <div class="scr__hero-amount">Rp6.420.000</div>
          <div class="scr__progress scr__progress--light"><span style="width: 71%"></span></div>
          <div class="scr__hero-meta">
            <span>71% dari anggaran Rp9.000.000</span>
            <span>19 hari lagi</span>
          </div>
        </div>

        <div class="scr__quick">
          <div class="scr__quick-item"><span class="scr__quick-icon"><i class="fa fa-minus-circle"></i></span>Catat</div>
          <div class="scr__quick-item"><span class="scr__quick-icon"><i class="fa fa-bolt"></i></span>Tagihan</div>
          <div class="scr__quick-item"><span class="scr__quick-icon"><i class="fa fa-shopping-basket"></i></span>Belanja</div>
          <div class="scr__quick-item"><span class="scr__quick-icon"><i class="fa fa-wrench"></i></span>Rawat</div>
        </div>

        <div class="scr__section-title">Hari ini <span>Sen, 12 Okt</span></div>
        <div class="scr__card scr__list">
          <div class="scr__row">
            <span class="scr__time">07:00</span>
            <div class="scr__row-main">
              <div class="scr__row-title">Antar sekolah Kirana</div>
              <div class="scr__row-sub">Ayah</div>
            </div>
            <span class="scr__avatar scr__avatar--sm scr__avatar--budi">B</span>
          </div>
          <div class="scr__row">
            <span class="scr__check scr__check--done"><i class="fa fa-check"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title scr__row-title--done">Buang sampah</div>
              <div class="scr__row-sub">Tugas · Bi Inah</div>
            </div>
            <span class="scr__avatar scr__avatar--sm scr__avatar--inah">I</span>
          </div>
          <div class="scr__row">
            <span class="scr__time">16:00</span>
            <div class="scr__row-main">
              <div class="scr__row-title">Les piano</div>
              <div class="scr__row-sub">2 hadir · 1 mungkin</div>
            </div>
            <span class="scr__avatar scr__avatar--sm scr__avatar--kirana">K</span>
          </div>
        </div>

        <div class="scr__section-title">Perlu perhatian</div>
        <div class="scr__card scr__alert">
          <span class="scr__tile scr__tile--amber"><i class="fa fa-bolt"></i></span>
          <div class="scr__row-main">
            <div class="scr__row-title">PLN Rumah Tangerang</div>
            <div class="scr__row-sub">Rp489.000 · jatuh tempo 20 Okt</div>
          </div>
          <span class="scr__pill-btn">Bayar</span>
        </div>
        <div class="scr__card scr__alert">
          <span class="scr__tile scr__tile--blue"><i class="fa fa-snowflake-o"></i></span>
          <div class="scr__row-main">
            <div class="scr__row-title">Servis AC kamar utama</div>
            <div class="scr__row-sub">3 hari lagi · Pak Joko</div>
          </div>
          <i class="fa fa-angle-right scr__chevron"></i>
        </div>
      </div>
    </template>

    <!-- ===== KAS & ANGGARAN ===== -->
    <template v-else-if="screen === 'budget'">
      <div class="scr__header">
        <div>
          <div class="scr__eyebrow">Kas &amp; Anggaran</div>
          <div class="scr__household">Oktober 2026 <i class="fa fa-angle-down"></i></div>
        </div>
        <span class="scr__icon-btn"><i class="fa fa-plus"></i></span>
      </div>
      <div class="scr__body">
        <div class="scr__segmented">
          <span class="scr__segmented-item scr__segmented-item--active">Bersama</span>
          <span class="scr__segmented-item"><i class="fa fa-lock"></i> Pribadi</span>
        </div>

        <div class="scr__split">
          <div class="scr__card scr__stat">
            <div class="scr__stat-label"><i class="fa fa-arrow-down scr__text-green"></i> Pemasukan</div>
            <div class="scr__stat-value">Rp15,0 jt</div>
          </div>
          <div class="scr__card scr__stat">
            <div class="scr__stat-label"><i class="fa fa-arrow-up scr__text-red"></i> Pengeluaran</div>
            <div class="scr__stat-value">Rp6,42 jt</div>
          </div>
        </div>

        <div class="scr__section-title">Anggaran kategori</div>
        <div class="scr__card scr__budgets">
          <div v-for="b in budgets" :key="b.name" class="scr__budget">
            <div class="scr__budget-head">
              <span>{{ b.name }}</span>
              <span :class="{ 'scr__text-red': b.pct >= 100, 'scr__text-amber': b.pct >= 80 && b.pct < 100 }">
                {{ b.pct }}%
              </span>
            </div>
            <div class="scr__progress">
              <span :style="{ width: Math.min(b.pct, 100) + '%' }"
                :class="{ 'is-warn': b.pct >= 80 && b.pct < 100, 'is-over': b.pct >= 100 }"></span>
            </div>
            <div class="scr__budget-meta">{{ b.spent }} dari {{ b.limit }}</div>
          </div>
        </div>

        <div class="scr__section-title">Transaksi terbaru</div>
        <div class="scr__card scr__list">
          <div class="scr__row">
            <span class="scr__tile scr__tile--green"><i class="fa fa-shopping-basket"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">Belanja mingguan</div>
              <div class="scr__row-sub">Rina · Belanja Dapur</div>
            </div>
            <span class="scr__amount">-412.500</span>
          </div>
          <div class="scr__row">
            <span class="scr__tile scr__tile--blue"><i class="fa fa-snowflake-o"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">Servis AC <span class="scr__chip">otomatis</span></div>
              <div class="scr__row-sub">dari Perawatan</div>
            </div>
            <span class="scr__amount">-250.000</span>
          </div>
        </div>
      </div>
    </template>

    <!-- ===== BAYAR TAGIHAN ===== -->
    <template v-else-if="screen === 'bills'">
      <div class="scr__header">
        <div class="scr__header-back">
          <i class="fa fa-chevron-left"></i>
          <div>
            <div class="scr__eyebrow">Tagihan</div>
            <div class="scr__household">PLN Pascabayar</div>
          </div>
        </div>
        <span class="scr__icon-btn"><i class="fa fa-history"></i></span>
      </div>
      <div class="scr__body">
        <div class="scr__bill-card">
          <div class="scr__bill-top">
            <span class="scr__bill-logo"><i class="fa fa-bolt"></i></span>
            <div>
              <div class="scr__bill-label">Rumah Tangerang</div>
              <div class="scr__bill-id">ID 5321 •••• 8812</div>
            </div>
          </div>
          <div class="scr__bill-grid">
            <div><span>Nama</span>R. SANTOSO</div>
            <div><span>Periode</span>Okt 2026</div>
            <div><span>Pemakaian</span>312 kWh</div>
            <div><span>Jatuh tempo</span>20 Okt</div>
          </div>
        </div>

        <div class="scr__card scr__breakdown">
          <div><span>Tagihan</span><span>Rp486.500</span></div>
          <div><span>Biaya admin</span><span>Rp2.500</span></div>
          <div class="scr__breakdown-total"><span>Total</span><span>Rp489.000</span></div>
        </div>

        <div class="scr__section-title">Bayar dengan</div>
        <div class="scr__methods">
          <span class="scr__method scr__method--active"><i class="fa fa-qrcode"></i> QRIS</span>
          <span class="scr__method"><i class="fa fa-university"></i> VA</span>
          <span class="scr__method"><i class="fa fa-mobile"></i> E-wallet</span>
        </div>

        <div class="scr__section-title">Pemakaian 6 bulan</div>
        <div class="scr__card scr__bars">
          <div v-for="(m, i) in usage" :key="m.label" class="scr__bar">
            <span :style="{ height: m.value + '%' }" :class="{ 'is-current': i === usage.length - 1 }"></span>
            <small>{{ m.label }}</small>
          </div>
        </div>
      </div>
      <div class="scr__cta-bar">
        <span class="scr__cta">Bayar Rp489.000</span>
      </div>
    </template>

    <!-- ===== AGENDA ===== -->
    <template v-else-if="screen === 'agenda'">
      <div class="scr__header">
        <div>
          <div class="scr__eyebrow">Agenda Keluarga</div>
          <div class="scr__household">Oktober 2026 <i class="fa fa-angle-down"></i></div>
        </div>
        <span class="scr__icon-btn"><i class="fa fa-calendar"></i></span>
      </div>
      <div class="scr__body">
        <div class="scr__week">
          <div v-for="d in week" :key="d.date" class="scr__day" :class="{ 'scr__day--active': d.active }">
            <small>{{ d.name }}</small>
            <strong>{{ d.date }}</strong>
            <span v-if="d.dot" class="scr__day-dot"></span>
          </div>
        </div>

        <div class="scr__timeline">
          <div class="scr__event scr__event--purple">
            <div class="scr__event-time">07:00</div>
            <div class="scr__event-body">
              <div class="scr__row-title">Antar sekolah</div>
              <div class="scr__row-sub">Ayah · berulang Sen–Jum</div>
            </div>
          </div>
          <div class="scr__event scr__event--green">
            <div class="scr__event-time">10:00</div>
            <div class="scr__event-body">
              <div class="scr__row-title">Buang sampah</div>
              <div class="scr__row-sub">Bi Inah · Sel &amp; Jum</div>
            </div>
          </div>
          <div class="scr__event scr__event--pink">
            <div class="scr__event-time">16:00</div>
            <div class="scr__event-body">
              <div class="scr__row-title">Les piano Kirana</div>
              <div class="scr__avatars">
                <span class="scr__avatar scr__avatar--xs scr__avatar--kirana">K</span>
                <span class="scr__avatar scr__avatar--xs scr__avatar--rina">R</span>
                <span class="scr__rsvp-note">2 hadir</span>
              </div>
            </div>
          </div>
          <div class="scr__event scr__event--amber">
            <div class="scr__event-time">19:30</div>
            <div class="scr__event-body">
              <div class="scr__row-title">Arisan keluarga besar</div>
              <div class="scr__row-sub"><i class="fa fa-map-marker"></i> Rumah Eyang</div>
              <div class="scr__rsvp">
                <span class="scr__rsvp-btn scr__rsvp-btn--yes">Hadir</span>
                <span class="scr__rsvp-btn">Mungkin</span>
                <span class="scr__rsvp-btn">Tidak</span>
              </div>
            </div>
          </div>
          <div class="scr__event scr__event--muted">
            <div class="scr__event-time">20 Okt</div>
            <div class="scr__event-body">
              <div class="scr__row-title"><i class="fa fa-bolt"></i> Jatuh tempo PLN</div>
              <div class="scr__row-sub">dari Tagihan</div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- ===== DAFTAR BELANJA ===== -->
    <template v-else-if="screen === 'shopping'">
      <div class="scr__header">
        <div class="scr__header-back">
          <i class="fa fa-chevron-left"></i>
          <div>
            <div class="scr__eyebrow">Daftar</div>
            <div class="scr__household">Belanja Mingguan</div>
          </div>
        </div>
        <div class="scr__avatars scr__avatars--stack">
          <span class="scr__avatar scr__avatar--xs scr__avatar--rina">R</span>
          <span class="scr__avatar scr__avatar--xs scr__avatar--inah">I</span>
          <span class="scr__avatar scr__avatar--xs scr__avatar--budi">B</span>
        </div>
      </div>
      <div class="scr__body">
        <div class="scr__live">
          <span class="scr__live-dot"></span>
          Bi Inah mencentang <strong>Telur</strong> · baru saja
        </div>
        <div class="scr__card scr__list">
          <div v-for="item in groceries" :key="item.name" class="scr__row">
            <span class="scr__check" :class="{ 'scr__check--done': item.done }">
              <i v-if="item.done" class="fa fa-check"></i>
            </span>
            <div class="scr__row-main">
              <div class="scr__row-title" :class="{ 'scr__row-title--done': item.done }">{{ item.name }}</div>
              <div class="scr__row-sub">{{ item.qty }}</div>
            </div>
            <span v-if="item.by" class="scr__avatar scr__avatar--xs" :class="'scr__avatar--' + item.by">
              {{ item.by.charAt(0).toUpperCase() }}
            </span>
          </div>
        </div>
        <div class="scr__estimate">
          <span>Perkiraan total</span>
          <strong>Rp418.000</strong>
        </div>
      </div>
      <div class="scr__cta-bar">
        <span class="scr__cta"><i class="fa fa-check-circle"></i> Selesai belanja · catat ke Kas</span>
      </div>
    </template>

    <!-- ===== PERAWATAN ===== -->
    <template v-else-if="screen === 'maintenance'">
      <div class="scr__header">
        <div>
          <div class="scr__eyebrow">Perawatan Rumah</div>
          <div class="scr__household">Kesehatan rumah</div>
        </div>
        <span class="scr__icon-btn"><i class="fa fa-plus"></i></span>
      </div>
      <div class="scr__body">
        <div class="scr__health">
          <div class="scr__health-item scr__health-item--red"><strong>1</strong><span>Terlambat</span></div>
          <div class="scr__health-item scr__health-item--amber"><strong>3</strong><span>Bulan ini</span></div>
          <div class="scr__health-item"><strong>12</strong><span>Terjadwal</span></div>
        </div>
        <div class="scr__card scr__list">
          <div class="scr__row">
            <span class="scr__tile scr__tile--red"><i class="fa fa-car"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">Pajak STNK Avanza</div>
              <div class="scr__row-sub scr__text-red">Terlambat 2 hari</div>
            </div>
            <i class="fa fa-angle-right scr__chevron"></i>
          </div>
          <div class="scr__row">
            <span class="scr__tile scr__tile--blue"><i class="fa fa-snowflake-o"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">Servis AC kamar utama</div>
              <div class="scr__row-sub">15 Okt · tiap 3 bulan</div>
            </div>
            <span class="scr__avatar scr__avatar--xs scr__avatar--vendor">J</span>
          </div>
          <div class="scr__row">
            <span class="scr__tile scr__tile--teal"><i class="fa fa-tint"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">Kuras toren air</div>
              <div class="scr__row-sub">25 Okt · tiap 6 bulan</div>
            </div>
            <i class="fa fa-angle-right scr__chevron"></i>
          </div>
          <div class="scr__row">
            <span class="scr__tile scr__tile--green"><i class="fa fa-home"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">PBB 2026</div>
              <div class="scr__row-sub scr__text-green">Lunas · 4 Agu</div>
            </div>
            <i class="fa fa-check-circle scr__text-green"></i>
          </div>
        </div>

        <div class="scr__section-title">Buku tukang</div>
        <div class="scr__card scr__vendor">
          <span class="scr__avatar scr__avatar--vendor">J</span>
          <div class="scr__row-main">
            <div class="scr__row-title">Pak Joko Service AC</div>
            <div class="scr__row-sub"><i class="fa fa-star scr__text-amber"></i> 4,8 · 6 pekerjaan</div>
          </div>
          <span class="scr__wa"><i class="fa fa-whatsapp"></i></span>
        </div>
      </div>
    </template>

    <!-- ===== CHAT ===== -->
    <template v-else-if="screen === 'chat'">
      <div class="scr__header">
        <div class="scr__header-back">
          <i class="fa fa-chevron-left"></i>
          <div>
            <div class="scr__household">Keluarga Santoso</div>
            <div class="scr__eyebrow">5 anggota · 3 online</div>
          </div>
        </div>
        <span class="scr__icon-btn"><i class="fa fa-ellipsis-h"></i></span>
      </div>
      <div class="scr__body scr__chat">
        <div class="scr__msg">
          <span class="scr__avatar scr__avatar--xs scr__avatar--budi">B</span>
          <div class="scr__bubble">Tagihan listrik bulan ini sudah keluar ya</div>
        </div>
        <div class="scr__msg">
          <span class="scr__avatar scr__avatar--xs scr__avatar--budi">B</span>
          <div class="scr__chat-card">
            <div class="scr__chat-card-head"><i class="fa fa-bolt"></i> Tagihan</div>
            <div class="scr__row-title">PLN Rumah Tangerang</div>
            <div class="scr__chat-card-amount">Rp489.000</div>
            <div class="scr__row-sub">Jatuh tempo 20 Okt</div>
            <div class="scr__chat-card-status"><i class="fa fa-check-circle"></i> Lunas oleh Rina</div>
          </div>
        </div>
        <div class="scr__msg scr__msg--me">
          <div class="scr__bubble scr__bubble--me">Sudah Bunda bayar barusan 👍</div>
        </div>
        <div class="scr__msg">
          <span class="scr__avatar scr__avatar--xs scr__avatar--eyang">E</span>
          <div class="scr__chat-card">
            <div class="scr__chat-card-head"><i class="fa fa-calendar"></i> Acara</div>
            <div class="scr__row-title">Arisan keluarga besar</div>
            <div class="scr__row-sub">Sab, 17 Okt · 19:30</div>
            <div class="scr__rsvp">
              <span class="scr__rsvp-btn scr__rsvp-btn--yes">Hadir</span>
              <span class="scr__rsvp-btn">Mungkin</span>
            </div>
          </div>
        </div>
        <div class="scr__msg">
          <span class="scr__avatar scr__avatar--xs scr__avatar--kirana">K</span>
          <div class="scr__bubble">Aku ikut! 🎉</div>
        </div>
      </div>
      <div class="scr__composer">
        <span class="scr__composer-input">Tulis pesan…</span>
        <span class="scr__composer-send"><i class="fa fa-paper-plane"></i></span>
      </div>
    </template>

    <div v-if="navActive" class="scr__nav">
      <div v-for="item in navItems" :key="item.key" class="scr__nav-item"
        :class="{ 'scr__nav-item--active': item.key === navActive }">
        <i :class="item.icon"></i>
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppScreen",
  props: {
    screen: { type: String, required: true },
  },
  computed: {
    // Screens with their own action bar (bills, shopping, chat) hide the bottom nav
    navActive() {
      return { home: "home", budget: "budget", agenda: "agenda", maintenance: "more" }[this.screen] || null;
    },
  },
  data() {
    return {
      navItems: [
        { key: "home", icon: "fa fa-home", label: "Beranda" },
        { key: "budget", icon: "fa fa-pie-chart", label: "Kas" },
        { key: "agenda", icon: "fa fa-calendar", label: "Agenda" },
        { key: "chat", icon: "fa fa-comments", label: "Chat" },
        { key: "more", icon: "fa fa-th-large", label: "Lainnya" },
      ],
      budgets: [
        { name: "Belanja Dapur", pct: 86, spent: "Rp2,15 jt", limit: "Rp2,5 jt" },
        { name: "Pendidikan", pct: 100, spent: "Rp1,8 jt", limit: "Rp1,8 jt" },
        { name: "Listrik & Air", pct: 64, spent: "Rp579 rb", limit: "Rp900 rb" },
      ],
      usage: [
        { label: "Mei", value: 52 },
        { label: "Jun", value: 74 },
        { label: "Jul", value: 45 },
        { label: "Agu", value: 63 },
        { label: "Sep", value: 95 },
        { label: "Okt", value: 80 },
      ],
      week: [
        { name: "Sen", date: 12, active: true, dot: true },
        { name: "Sel", date: 13, dot: true },
        { name: "Rab", date: 14 },
        { name: "Kam", date: 15, dot: true },
        { name: "Jum", date: 16, dot: true },
        { name: "Sab", date: 17, dot: true },
        { name: "Min", date: 18 },
      ],
      groceries: [
        { name: "Beras", qty: "5 kg", done: true, by: "inah" },
        { name: "Telur", qty: "1 kg", done: true, by: "inah" },
        { name: "Minyak goreng", qty: "2 L", done: false },
        { name: "Susu UHT", qty: "6 kotak", done: false, by: "budi" },
        { name: "Bayam", qty: "2 ikat", done: false },
        { name: "Sabun cuci piring", qty: "1 botol", done: false },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
$ink: #1a0a2e;
$muted: #8a809a;
$line: #efeaf4;
$purple: #6c2973;
$magenta: #c73468;
$grad: linear-gradient(135deg, $purple, $magenta);

.scr {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  color: $ink;
  font-size: 11px;
}

// ----- Header -----
.scr__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 12px;
  background: #fff;
  border-bottom: 1px solid $line;
  flex-shrink: 0;
}

.scr__header-back {
  display: flex;
  align-items: center;
  gap: 10px;

  > i {
    font-size: 11px;
    color: $purple;
  }
}

.scr__eyebrow {
  font-size: 10px;
  color: $muted;
}

.scr__household {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 14px;
  font-weight: 800;
  color: $ink;

  i {
    font-size: 11px;
    color: $magenta;
  }
}

.scr__header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.scr__icon-btn {
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 10px;
  background: #f4eff8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: $purple;
  font-size: 12px;
}

.scr__badge-dot {
  position: absolute;
  top: 6px;
  right: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: $magenta;
  border: 1px solid #fff;
}

// ----- Body -----
.scr__body {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 12px 14px;
}

.scr__card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(26, 10, 46, 0.06);
  margin-bottom: 10px;
}

.scr__section-title {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 700;
  margin: 12px 2px 6px;

  span {
    font-weight: 500;
    color: $muted;
  }
}

.scr__list {
  padding: 2px 0;
}

.scr__row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;

  & + & {
    border-top: 1px solid $line;
  }
}

.scr__row-main {
  flex: 1;
  min-width: 0;
}

.scr__row-title {
  font-weight: 600;
  font-size: 11.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &--done {
    color: $muted;
    text-decoration: line-through;
  }
}

.scr__row-sub {
  font-size: 10px;
  color: $muted;
  margin-top: 1px;
}

.scr__time {
  font-size: 10px;
  font-weight: 700;
  color: $purple;
  width: 32px;
}

.scr__chevron {
  color: #c9bfd4;
  font-size: 13px;
}

.scr__amount {
  font-weight: 700;
  font-size: 11px;
}

.scr__chip {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 20px;
  background: rgba(199, 52, 104, 0.1);
  color: $magenta;
  font-size: 8.5px;
  font-weight: 700;
  vertical-align: middle;
}

// ----- Avatars & tiles -----
.scr__avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 11px;
  flex-shrink: 0;

  &--sm {
    width: 22px;
    height: 22px;
    font-size: 9px;
  }

  &--xs {
    width: 20px;
    height: 20px;
    font-size: 8.5px;
  }

  &--rina { background: $magenta; }
  &--budi { background: $purple; }
  &--kirana { background: #e08a3c; }
  &--inah { background: #2f9e7a; }
  &--vendor { background: #3a7bd5; }
  &--eyang { background: #8a5cc2; }
}

.scr__avatars {
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 4px;

  &--stack {
    margin-top: 0;
    gap: 0;

    .scr__avatar {
      border: 2px solid #fff;
      margin-left: -6px;
    }
  }
}

.scr__tile {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;

  &--amber { background: #fff3dc; color: #d48806; }
  &--blue { background: #e6f0fd; color: #3a7bd5; }
  &--green { background: #e3f6ee; color: #2f9e7a; }
  &--red { background: #fde7ec; color: #d63a5a; }
  &--teal { background: #e0f5f6; color: #1f9aa3; }
}

.scr__text-green { color: #2f9e7a; }
.scr__text-red { color: #d63a5a; }
.scr__text-amber { color: #d48806; }

// ----- Progress -----
.scr__progress {
  height: 6px;
  border-radius: 6px;
  background: #f1ebf6;
  overflow: hidden;

  span {
    display: block;
    height: 100%;
    border-radius: 6px;
    background: $grad;

    &.is-warn { background: #f0a43a; }
    &.is-over { background: #d63a5a; }
  }

  &--light {
    background: rgba(255, 255, 255, 0.25);

    span { background: #fff; }
  }
}

// ----- Home -----
.scr__hero-card {
  background: $grad;
  border-radius: 16px;
  padding: 14px;
  color: #fff;
  box-shadow: 0 8px 20px rgba(199, 52, 104, 0.3);
}

.scr__hero-label {
  font-size: 10px;
  opacity: 0.8;
}

.scr__hero-amount {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 20px;
  font-weight: 800;
  margin: 2px 0 10px;
}

.scr__hero-meta {
  display: flex;
  justify-content: space-between;
  font-size: 9.5px;
  opacity: 0.85;
  margin-top: 6px;
}

.scr__quick {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-top: 12px;
}

.scr__quick-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-size: 9.5px;
  font-weight: 600;
}

.scr__quick-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $magenta;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(26, 10, 46, 0.08);
}

.scr__check {
  width: 18px;
  height: 18px;
  border-radius: 6px;
  border: 1.5px solid #cfc4da;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: #fff;
  flex-shrink: 0;

  &--done {
    background: #2f9e7a;
    border-color: #2f9e7a;
  }
}

.scr__alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
}

.scr__pill-btn {
  padding: 5px 12px;
  border-radius: 20px;
  background: $grad;
  color: #fff;
  font-weight: 700;
  font-size: 10px;
}

// ----- Budget -----
.scr__segmented {
  display: flex;
  background: #ece5f3;
  border-radius: 10px;
  padding: 3px;
  margin-bottom: 10px;
}

.scr__segmented-item {
  flex: 1;
  text-align: center;
  padding: 5px;
  border-radius: 8px;
  font-weight: 600;
  color: $muted;

  &--active {
    background: #fff;
    color: $purple;
    box-shadow: 0 1px 3px rgba(26, 10, 46, 0.1);
  }
}

.scr__split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.scr__stat {
  padding: 10px 12px;
  margin-bottom: 0;
}

.scr__stat-label {
  font-size: 9.5px;
  color: $muted;
}

.scr__stat-value {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 800;
  font-size: 14px;
  margin-top: 2px;
}

.scr__budgets {
  padding: 10px 12px;
}

.scr__budget + .scr__budget {
  margin-top: 9px;
}

.scr__budget-head {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  margin-bottom: 4px;
}

.scr__budget-meta {
  font-size: 9px;
  color: $muted;
  margin-top: 3px;
}

// ----- Bills -----
.scr__bill-card {
  background: linear-gradient(135deg, #2a1245, $purple);
  border-radius: 16px;
  padding: 14px;
  color: #fff;
  margin-bottom: 10px;
}

.scr__bill-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.scr__bill-logo {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #ffd23f;
  color: #2a1245;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}

.scr__bill-label {
  font-weight: 700;
  font-size: 12.5px;
}

.scr__bill-id {
  font-size: 9.5px;
  opacity: 0.7;
}

.scr__bill-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  font-weight: 700;
  font-size: 11px;

  span {
    display: block;
    font-weight: 400;
    font-size: 9px;
    opacity: 0.65;
  }
}

.scr__breakdown {
  padding: 8px 12px;

  > div {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    color: #5a5068;
  }
}

.scr__breakdown-total {
  border-top: 1px dashed #ddd3e6;
  margin-top: 4px;
  padding-top: 8px !important;
  font-weight: 800;
  color: $ink !important;
  font-size: 12.5px;
}

.scr__methods {
  display: flex;
  gap: 6px;
}

.scr__method {
  flex: 1;
  text-align: center;
  padding: 7px 4px;
  border-radius: 10px;
  background: #fff;
  border: 1.5px solid $line;
  font-weight: 600;
  font-size: 10px;

  &--active {
    border-color: $magenta;
    color: $magenta;
    background: rgba(199, 52, 104, 0.05);
  }
}

.scr__bars {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 78px;
  padding: 10px 14px 6px;
}

.scr__bar {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 3px;

  span {
    width: 14px;
    border-radius: 4px;
    background: #e6dcef;

    &.is-current {
      background: $grad;
    }
  }

  small {
    font-size: 8.5px;
    color: $muted;
  }
}

.scr__cta-bar {
  padding: 10px 14px 18px;
  background: #fff;
  border-top: 1px solid $line;
  flex-shrink: 0;
}

.scr__cta {
  display: block;
  text-align: center;
  padding: 11px;
  border-radius: 14px;
  background: $grad;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  box-shadow: 0 6px 16px rgba(199, 52, 104, 0.35);
}

// ----- Agenda -----
.scr__week {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.scr__day {
  position: relative;
  width: 32px;
  padding: 6px 0 9px;
  border-radius: 12px;
  text-align: center;

  small {
    display: block;
    font-size: 8.5px;
    color: $muted;
  }

  strong {
    font-size: 12.5px;
  }

  &--active {
    background: $grad;
    color: #fff;
    box-shadow: 0 6px 14px rgba(199, 52, 104, 0.35);

    small { color: rgba(255, 255, 255, 0.8); }
    .scr__day-dot { background: #fff; }
  }
}

.scr__day-dot {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: $magenta;
}

.scr__event {
  display: flex;
  gap: 10px;
  margin-bottom: 8px;
}

.scr__event-time {
  width: 34px;
  font-size: 9.5px;
  font-weight: 700;
  color: $muted;
  padding-top: 8px;
  flex-shrink: 0;
}

.scr__event-body {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 12px;
  padding: 8px 10px;
  border-left: 3px solid $purple;
  box-shadow: 0 1px 3px rgba(26, 10, 46, 0.06);
}

.scr__event--green .scr__event-body { border-left-color: #2f9e7a; }
.scr__event--pink .scr__event-body { border-left-color: $magenta; }
.scr__event--amber .scr__event-body { border-left-color: #f0a43a; }

.scr__event--muted .scr__event-body {
  border-left-color: #cfc4da;
  background: #f1ecf6;
  box-shadow: none;
}

.scr__rsvp {
  display: flex;
  gap: 4px;
  margin-top: 6px;
}

.scr__rsvp-btn {
  padding: 3px 9px;
  border-radius: 20px;
  border: 1px solid #ddd3e6;
  font-size: 9.5px;
  font-weight: 600;
  color: #5a5068;

  &--yes {
    background: #2f9e7a;
    border-color: #2f9e7a;
    color: #fff;
  }
}

.scr__rsvp-note {
  font-size: 9.5px;
  color: $muted;
  margin-left: 2px;
}

// ----- Shopping -----
.scr__live {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border-radius: 10px;
  background: #e3f6ee;
  color: #1f7a5c;
  font-size: 10px;
  margin-bottom: 10px;
}

.scr__live-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2f9e7a;
  box-shadow: 0 0 0 3px rgba(47, 158, 122, 0.25);
  animation: scr-pulse 1.6s ease-in-out infinite;
}

@keyframes scr-pulse {
  50% { box-shadow: 0 0 0 6px rgba(47, 158, 122, 0); }
}

.scr__estimate {
  display: flex;
  justify-content: space-between;
  padding: 2px 4px;
  color: $muted;

  strong {
    color: $ink;
  }
}

// ----- Maintenance -----
.scr__health {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  margin-bottom: 10px;
}

.scr__health-item {
  background: #fff;
  border-radius: 12px;
  padding: 8px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(26, 10, 46, 0.06);

  strong {
    display: block;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 17px;
    font-weight: 800;
  }

  span {
    font-size: 9px;
    color: $muted;
  }

  &--red strong { color: #d63a5a; }
  &--amber strong { color: #d48806; }
}

.scr__vendor {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
}

.scr__wa {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #25d366;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}

// ----- Chat -----
.scr__chat {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 8px;
  background: #f3eef7;
}

.scr__msg {
  display: flex;
  align-items: flex-end;
  gap: 6px;

  &--me {
    justify-content: flex-end;
  }
}

.scr__bubble {
  max-width: 75%;
  padding: 7px 10px;
  border-radius: 12px 12px 12px 4px;
  background: #fff;
  font-size: 11px;
  box-shadow: 0 1px 2px rgba(26, 10, 46, 0.06);

  &--me {
    border-radius: 12px 12px 4px 12px;
    background: $grad;
    color: #fff;
  }
}

.scr__chat-card {
  width: 72%;
  background: #fff;
  border-radius: 12px 12px 12px 4px;
  padding: 9px 10px;
  border: 1px solid #e8dff0;
}

.scr__chat-card-head {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: $magenta;
  margin-bottom: 3px;
}

.scr__chat-card-amount {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 800;
  font-size: 14px;
}

.scr__chat-card-status {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid $line;
  color: #2f9e7a;
  font-weight: 600;
  font-size: 10px;
}

.scr__composer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px 18px;
  background: #fff;
  border-top: 1px solid $line;
  flex-shrink: 0;
}

.scr__composer-input {
  flex: 1;
  padding: 8px 12px;
  border-radius: 20px;
  background: #f4eff8;
  color: $muted;
}

.scr__composer-send {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: $grad;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

// ----- Bottom nav -----
.scr__nav {
  display: flex;
  justify-content: space-around;
  padding: 8px 6px 16px;
  background: #fff;
  border-top: 1px solid $line;
  flex-shrink: 0;
}

.scr__nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 8.5px;
  color: #a79cb5;

  i {
    font-size: 14px;
  }

  &--active {
    color: $magenta;
    font-weight: 700;
  }
}
</style>
